import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ProteticosList from '../../components/Protetico/ProteticosList'

const mapStateToProps = (store) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProteticosList)
